import { h } from "preact";

import Datepicker from "../Datepicker.jsx";
import { getTextOfAnswer } from "./helper.js";
import { checkDateValidity } from "../../helpers.js";

export default function Date(props) {
  const answer = getTextOfAnswer(props.answer);

  function handleChange(value) {
    props.onSelect(
      value,
      null,
      checkDateValidity(value)
        ? null
        : "Please enter a date in the format dd/mm/yyyy."
    );
  }

  return (
    <div class="mb-32">
      <Datepicker
        {...props}
        name="answer"
        value={answer}
        info={props.error ? "" : props.options.helperText}
        error={props.error}
        label={props.options.label}
        min={props.options && props.options.min}
        max={props.options && props.options.max}
        onChange={handleChange}
      />
    </div>
  );
}
